const CrossIcon = ({ stroke = '#2A1846', ...otherProps }) => (
  <svg width='24' height='24' viewBox='0 0 24 24' {...otherProps}>
    <path
      d='M16 8L8 16'
      stroke={stroke}
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinecap='square'
    />
    <path
      d='M16 16L8 8'
      stroke={stroke}
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinecap='square'
    />
  </svg>
)

export default CrossIcon
